export default {
  meta: {
    title: '品牌管理',
  },
};
